module.exports = __webpack_public_path__ + "static/22-helado-82a02ced037d3c7488a4aa90e45ee376.jpg";